<form [formGroup]="codeForm">
  <div>
    <input #codeInput
           formControlName="code"
           type="text"
           class="form-control text-center"
           (paste)="onPaste($event)"
           (input)="onInput()"
           [(ngModel)]="formText"
           placeholder="Enter code"
           [class.is-invalid]="codeControl?.invalid && codeControl?.touched" />
    <div class="invalid-feedback">
      <div i18n>A 6 digit code must be entered.</div>
    </div>
    <button class="btn btn-success mt-3"
            (click)="save()">PAIR</button>
  </div>
</form>